<div *ngIf="this.isLoading" class="se-loader"></div>
<div class=" p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.haccpReportTitle|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
      <button class="se-button cursorPointerHand" id="addHaccpReport" (click)="AddReport()" [class.disabled]="btndiv">
        {{labels.btnAddReport | translate}}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div>
      <div class="rectangle-grid">
        <p-table #dt [columns]="cols" [value]="haccpReportDetail" [paginator]="isPagination" [rows]="10"
                 [globalFilterFields]="['reportName','configuration.notifyToEmailList']">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}"
                  [pSortableColumnDisabled]="col.field === 'notifyTo'">
                {{col.header | translate}}
                <p-sortIcon *ngIf="col.field!='notifyTo'" [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th scope="col" class="action-toggle-col">{{ labels.enableDisable | translate }}</th>
              <th scope="col" class="action-col">{{ labels.actions | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr class="rowHeight">
              <td class="rule-desc" *ngFor="let col of columns">
                <span [style.width]="col.width" *ngIf="col.field === 'frequency'">
                  {{rowData.frequency ===1 ? 'Daily' : '' }}
                  {{rowData.frequency === 2 ? 'Weekly' : '' }}
                  {{rowData.frequency ===3 ? 'Monthly' : '' }}
                </span>
                <span [style.width]="col.width" *ngIf="col.field !== 'id' && col.field!='frequency' && col.field!='notifyTo'" title="{{rowData[col.field]}}" appendTo="target" class="relativePosition">
                  {{rowData[col.field]}}
                </span>
                <span *ngIf="col.field === 'notifyTo'" class="overflow-wrap-bw ellipsis-tooltip" [style.width]="col.width" [title]="rowData.configuration.notifyToEmailList">
                  {{rowData.configuration.notifyToEmailList}}
                </span>
              </td>
              <td>
                <label class="se-block-action switch">
                  <input type="checkbox" [(ngModel)]="rowData.isActive" class="alarmrule-block-check" (click)="EditReportStatus(rowData, $event)"
                         (keypress)="EditReportStatus(rowData, $event)"
                         (keydown)="EditReportStatus(rowData, $event)"
                         (keyup)="EditReportStatus(rowData, $event)" />
                  <span class="slider round"></span>
                </label>
              </td>
              <td class="pl-1">
                <img src="assets/edit.svg" class="icon-action iconEditReport editIcon" (click)="EditReport(rowData)"
                     (keypress)="EditReport(rowData)" alt="edit" height="21" width="21"
                     (keydown)="EditReport(rowData)"
                     (keyup)="EditReport(rowData)" />
                <img src="assets/delete.svg" class="icon-action iconDeleteReport" (click)="DeleteReport(rowData, $event)" alt="delete" height="29" width="29"
                     (keypress)="DeleteReport(rowData, $event)"
                     (keydown)="DeleteReport(rowData, $event)"
                     (keyup)="DeleteReport(rowData, $event)" />
                <img src="assets/cloud-download.svg" class="icon-action iconHistoryReport cloud-download" (click)="OpenHistory(rowData, $event)"alt="cloud-download" height="24" width="24"
                     (keypress)="OpenHistory(rowData, $event)"
                     (keydown)="OpenHistory(rowData, $event)"
                     (keyup)="OpenHistory(rowData, $event)" />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noData">
              <td [attr.colspan]="columns.length + 2">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div class="se-dialog" *ngIf="showHistoryModal">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{historyReportName | translate}} {{labels.history | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <p-table [columns]="cols" [value]="reportHistory" [paginator]="isHistoryPagination" [rows]="12">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" class="history-col" *ngFor="let col of historyColumns" [pSortableColumn]="col.field"
                 [pSortableColumnDisabled]="col.field === 'downloadLink'">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" *ngIf="col.dataType=='date'" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="historyColumns" let-i="rowIndex">
          <tr class="heigth2em">
            <td class="rule-desc" *ngFor="let col of historyColumns">
              <span *ngIf="col.dataType=='date'" appendTo="target" class="relativePosition" dateFormat="dd/MM/yyyy HH:mm">
                {{rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
              </span>

              <!-- <a class="hlink" href="{{rowData[col.field]}}" *ngIf="col.field == 'downloadLink'">
                <img src="assets/download.svg" class="icon-action download-icon" alt="download" height="29" width="21"/>
              </a> -->
              <!-- <a class="hlink" href="{{rowData[col.field]}}" *ngIf="col.field == 'downloadLink'">
                <img src="assets/page-pdf.svg" class="icon-action download-icon reportFormatsImg" alt="pdf" title="{{labels.downloadPdf | translate}}" height="29" width="21"/>
              </a>
              <a class="hlink" href="{{rowData[col.field]}}" *ngIf="col.field == 'downloadLink'">
                <img src="assets/page-csv.svg" class="icon-action download-icon reportFormatsImg" alt="csv" title="{{labels.downloadCsv | translate}}" height="29" width="21"/>
              </a>
              <a class="hlink" href="{{rowData[col.field]}}" *ngIf="col.field == 'downloadLink'">
                <img src="assets/page-xlsx.svg" class="icon-action download-icon reportFormatsImg" alt="xlsx" title="{{labels.downloadXlsx | translate}}" height="29" width="21"/>
              </a> -->
              <div *ngIf="col.field == 'downloadLink'">
                <ng-container *ngFor="let report of rowData.reportDetails">
                  <a class="hlink" [href]="report.downloadLink" target="_blank" *ngIf="report.reportFormat === 1">
                    <img src="assets/page-pdf.svg" class="icon-action download-icon reportFormatsImg" alt="pdf" title="{{labels.downloadPdf | translate}}" height="29" width="21"/>
                  </a>
                  <a class="hlink" [href]="report.downloadLink" target="_blank" *ngIf="report.reportFormat === 2">
                    <img src="assets/page-csv.svg" class="icon-action download-icon reportFormatsImg" alt="csv" title="{{labels.downloadCsv | translate}}" height="29" width="21"/>
                  </a>
                  <a class="hlink" [href]="report.downloadLink" target="_blank" *ngIf="report.reportFormat === 3">
                    <img src="assets/page-xlsx.svg" class="icon-action download-icon reportFormatsImg" alt="xlsx" title="{{labels.downloadXlsx | translate}}" height="29" width="21"/>
                  </a>
                </ng-container>
              </div>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="noHistoryData">
            <td [attr.colspan]="2">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeModal()">{{labels.cancel | translate}}</button>
    </div>
  </div>
</div>
<div class="se-dialog" *ngIf="showmodal">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{contentHeader | translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form">
        <div class="form-ele col-md-12">
          <label for="reportName" class="se-label col-md-3">
            {{labels.reportName | translate}}
            <span>*</span>
          </label>
          <input id="reportName" name="reportName" placeholder="{{labels.reportName | translate}}" type="text" 
          autocomplete="off" appRequiredElementValidator class="se-form-control col-md-8 reportWidth" #TxtReportName="ngModel" [(ngModel)]="reportName" #txtReportName (keyup)="validate()" [minLength]="1" [maxLength]="500">
          <div class="d-block brand-error se-fs-12" *ngIf="!TxtReportName.errors?.requiredElementValidator && (TxtReportName.dirty || TxtReportName.touched)">
            {{reportNameRequired}}
          </div>
        </div>
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3">
            {{ labels.ReportFrequency | translate}}
            <span>*</span>
          </label>
          <label class="radio-holder col-md-3">
            <span>{{labels.Daily | translate}}</span>
            <input class="radio" type="radio" name="reportFrequency" [value]='1' [(ngModel)]="reportFrequency" (change)="reportFrequencyChanged($event)" />
            <span class="checkmark" data-color="primary"></span>
          </label>
          <label class="radio-holder col-md-3">
            <span>{{labels.Weekly | translate}}</span>
            <input type="radio" name="reportFrequency" [value]='2' [(ngModel)]="reportFrequency" (change)="reportFrequencyChanged($event)" class="radio">
            <span class="checkmark" data-color="primary"></span>
          </label>
          <label class="radio-holder col-md-3">
            <span>{{labels.Monthly | translate}}</span>
            <input type="radio" name="reportFrequency" [value]='3' [(ngModel)]="reportFrequency" (change)="reportFrequencyChanged($event)" class="radio">
            <span class="checkmark" data-color="primary"></span>
          </label>
        </div>
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3">
            <span></span>
          </label>
          <div class="col-md-12">
            <img src="assets/info.svg" [ngStyle]="(reportFrequency === 3) ? {'margin-left': '4px', 'margin-top': '-28px'} : {'margin-left': '4px'}" style="margin-left: 4px;" class="icon-action info-icon" alt="info" height="15" width="15"/>
            <span *ngIf="reportFrequency === 1" class="reportInfo">{{labels.reportFrequencyLabel1 | translate}}</span>
            <span *ngIf="reportFrequency === 2" class="reportInfo">{{labels.reportFrequencyLabel2}}</span>
            <span *ngIf="reportFrequency === 3" class="reportInfo firstMeasurment">{{labels.reportFrequencyLabel3}}</span>
          </div>
        </div>
        <div class="form-ele col-md-12">
          <label for="drpDataFreq" class="se-label col-md-3">
            {{labels.dataFrequency | translate}}
            <span>*</span>
          </label>
          <select id="drpDataFreq" class="se-form-control col-md-8 reportWidth" [(ngModel)]="selectedDataFreq" [minLength]="1" [maxLength]="50" (onchange)="validate()" (change)="getSelectedFeq()">
            <option *ngFor="let item of dataFrequencyList; let i = index" [ngValue]="item.value" >{{item.desc|translate}}</option>
          </select>
          <div class="d-block brand-error se-fs-12" *ngIf="reportFrequency>0 && selectedDataFreq==0"> {{labels.DataFreqMandatory|translate}} </div>
        </div>
        <div class="form-ele col-md-12" *ngIf="selectedDataFreq">
          
            <label class="se-label col-md-3">
              <span> </span>
            </label>
          
           
          <div class="col-md-8" style="width: 100%;">
            <img src="assets/info.svg" [ngStyle]="(selectedDataFreq === 1 || selectedDataFreq === 2) ? {'margin-left': '4px', 'margin-top': '-16px'} : {'margin-left': '4px'}" class="icon-action info-icon" alt="info" height="15" width="15"/>
            <span *ngIf="selectedDataFreq === 1" class="reportInfo firstMeasurment">{{labels.dataFrequencyCommonLabel}} <b> {{labels.onetimeperday}} </b> each day.</span>
            <span *ngIf="selectedDataFreq === 2" class="reportInfo firstMeasurment">{{labels.dataFrequencyCommonLabel}} <b> {{labels.twotimeperday}} </b> and <b> {{labels.timeslots1224}}</b>.</span>
            <span *ngIf="selectedDataFreq === 3" class="reportInfo">{{labels.dataFrequencyCommonLabel}} <b> {{labels.dataFrequencyLabel3}} </b> 
              <ul class="timeSlots">
                <li>00:00 - 08:00</li>
                <li>08:00 - 16:00</li>
                <li>16:00 - 24:00</li>
              </ul>
            </span>
            <span *ngIf="selectedDataFreq === 4" class="reportInfo">{{labels.dataFrequencyCommonLabel}} <b> {{labels.dataFrequencyLabel4}}  </b>
             <ul class="timeSlots">
                <li>00:00 - 06:00</li>
                <li>06:00 - 12:00</li>
                <li>12:00 - 18:00</li>
                <li>18:00 - 24:00</li>
              </ul>
            </span>
          </div>
        </div>

        <div class="form-ele col-md-12 ">
          <label class="se-label col-md-3">
            {{labels.selectDevice | translate}}
            <span>*</span>
          </label>
          <p-dropdown name="devices" [filter]="true"
                      optionLabel="name" optionValue="dongleId" [options]="applyToDeviceData"
                      [(ngModel)]="selectedDevice" placeholder="Select Device" (onChange)="DeviceSelectionChanged($event)"
                      #devices="ngModel" class="input-content-drp col-md-8">
          </p-dropdown>

          <div class="d-block brand-error se-fs-12" *ngIf="selectedDevice==null && reportName!=''"> {{labels.DeviceMandatory|translate}}</div>
        </div>
        <div class="form-ele col-md-12">
          <label class="se-label col-md-2">
            {{labels.resources | translate}}
            <span>*</span>
          </label>
          <p-multiSelect class="input-content-drp col-md-10 pl-40" (onChange)="ResourceSelectionChanged(this,$event)"
                         [options]="resourceData" [(ngModel)]="selectedResource" placeholder="Select Resource"
                         optionValue="value" optionLabel="key" display="chip"></p-multiSelect>

          <div class="d-block brand-error se-fs-12" *ngIf="selectedResource.length==0 && selectedDevice!=null">
            {{labels.ResourceMandatory|translate}}
          </div>
          <div class="d-block brand-error se-fs-12" *ngIf="selectedResource.length>8">
            {{labels.MaxResourceSelected|translate}}
          </div>
        </div>
        
        <div class="form-ele col-md-12">
          <label for="notifyEmail" class="se-label col-md-3">
            {{labels.reportReceiverEmail | translate}}
            <span>*</span>
          </label>
          <input readonly id="notifyEmail" name="notifyEmail" style="width: 63%;" placeholder="{{labels.email | translate}}" type="text" autocomplete="off" 
          appRequiredElementValidator class="se-form-control col-md-8" #TxtReportName="ngModel" [(ngModel)]="defaultLoggedEmail" (keyup)="validate()" [minLength]="1" [maxLength]="500">
          <button class="se-button button-primary" (click)="showInputboxs()">+</button>
          
        </div>
        <div class="form-ele col-md-12 email-scroll-box" *ngIf="displayInputBoxs">
          
          <div *ngFor="let email of emialIds; let idx = index; trackBy: trackByIndex" >
            <label for="recepientemail" class="se-label col-md-3"><span></span></label>
            <input id="recepientemail" name="recepientemail" 
            [ngStyle]="emialIds.length > 1 ? {'width': '421px', 'margin-left': '13px', 'margin-right': '0px'} : {'width': '421px', 'margin-left': '8px', 'margin-right': '0px'}"
            placeholder="Enter email" 
            type="text" autocomplete="off" 
            appRequiredElementValidator 
            class="se-form-control col-md-8" #TxtReportName="ngModel" 
            [(ngModel)]="emialIds[idx]" #txtReportName style="margin-bottom: 10px; width: 63%;">
            <button type="button" class="se-button padding-left" style="margin-top:-9px; padding-right: 20px;" (click)="removeEmail(idx)">-</button>

          </div>
         
        </div>
        <!-- notified to email -->
        <!-- <div class="form-ele col-md-12" *ngIf="!CanOnlySelectThemself">
          <label class="se-label col-md-2">
            {{labels.notify| translate}}
            <span></span>
          </label>

          <p-multiSelect class="input-content-drp col-md-8 pl-40" (onChange)="NotifyToSelectionChange($event)"
                         [options]="applyToNotifyToData" [(ngModel)]="applyToNotifyName"
                         placeholder="Select User" optionValue="id"
                         optionLabel="name" display="chip"></p-multiSelect>
          
        </div> -->
  
        <div class="form-ele col-md-12">
          <label class="se-label col-md-3">
            {{ labels.format | translate}}
            <span>*</span>
          </label>
         
          <label class="checkbox-holder col-md-3" style="width: auto;">
            <input type="checkbox" name="reportFormatPdf" [(ngModel)]="reportFormatPdf" class="check" value="1" (change)="onReportFormatChange()"/>
            <span class="checkmark" data-color="primary"></span>
            <span>{{labels.Pdf | translate}}</span>
          </label>
          <label class="checkbox-holder col-md-3" style="width: auto;">
            <input type="checkbox" name="reportFormatCsv" [(ngModel)]="reportFormatCsv" class="check" value="2" (change)="onReportFormatChange()"/>
            <span class="checkmark" data-color="primary"></span>
            <span>{{labels.Csv | translate}}</span>
          </label>
          <label class="checkbox-holder col-md-3" style="width: auto;">
            <input type="checkbox" name="reportFormatExcel" [(ngModel)]="reportFormatExcel" class="check" value="3" (change)="onReportFormatChange()"/>
            <span class="checkmark" data-color="primary"></span>
            <span>{{labels.Excel | translate}}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeModal()">{{labels.cancel | translate}}</button>
      <button class="se-button button-primary" (click)="SaveReport()" [disabled]="formInvalid" [ngClass]="{ 'disabled-cls': formInvalid }">{{labels.saveAndApp | translate}}</button>
    </div>
  </div>
</div>
<div class="se-dialog" *ngIf="showDeletemodal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title">{{labels.DeleteReportHead| translate}} {{reportName}}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{this.messages.confirmDeleteReport| translate}}
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeModal()">{{labels.no | translate}}</button>
      <button class="se-button" (click)="onConfirm()">{{labels.yes | translate}}</button>
    </div>
  </div>
</div>
<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000"></p-toast>
